<template>
  <div>
    <!-- modal delete -->
    <v-dialog v-model="openDelete" width="600px">
      <v-card>
        <v-card-title class="headline red lighten-2 white--text">
          Suprimer un document
        </v-card-title>

        <h1 v-if="currentDocument" class="pa-10">
          {{ currentDocument.documentName }}
        </h1>

        <v-divider />

        <v-card-actions class="pa-5">
          <v-btn color="primary" outlined @click="openDelete = false">
            Annuler
          </v-btn>

          <v-spacer />

          <v-btn color="red" outlined @click="deleteDocument()">
            Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- modal element -->
    <v-dialog v-model="openNew" width="600px">
      <v-card>
        <v-card-title class="headline green white--text">
          {{ isCreate() ? "Ajouter un document" : "Modifier un document" }}
        </v-card-title>

        <div class="pa-8">
          <v-text-field
            v-model="newDocument.name"
            label="Nom pour les clients"
          />

          <v-file-input
            v-model="newDocument.document"
            :label="isCreate() ? 'Document' : newDocument.prevDocumentName"
          />
          <v-file-input
            v-model="newDocument.icon"
            :label="isCreate() ? 'Icon' : newDocument.prevIconName"
          />

          <v-select
            v-model="newDocument.commandCategories"
            :items="categories"
            chips
            item-text="name"
            item-value="id"
            label="Type de commande :"
            multiple
          />

          <v-autocomplete
            v-model="newDocument.clients"
            :items="clients"
            label="Visible uniquement pour :"
            item-text="name"
            item-value="id"
            chips
            clearable
            multiple
          ></v-autocomplete>

          <v-switch v-model="newDocument.visible" label="visible" />
        </div>

        <v-divider />

        <v-card-actions class="pa-5">
          <v-btn outlined @click="openNew = false"> Annuler </v-btn>

          <v-spacer />

          <v-btn
            :disabled="disabled"
            color="primary"
            outlined
            @click="isCreate() ? createNew() : update()"
          >
            {{ isCreate() ? "Creer" : "Update" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--    Actual code -->
    <div style="padding-top: 24px">
      <div style="width: 100%; margin: auto; max-width: 1400px">
        <h1 class="mb-3">{{ adminCat.name }}</h1>
        <div class="title mb-8">
          <div class="input-group searchBar mr-10">
            <div class="input-group-append">
              <div class="btn btn-secondary searchIcon" type="button">
                <i class="fa fa-search"></i>
              </div>
            </div>
            <input
              v-model="searchInput"
              class="form-control"
              placeholder="Rechercher"
              type="text"
            />
          </div>

          <v-btn class="mr-6" outlined @click="openNewModal"
            >Ajouter un document
          </v-btn>
        </div>

        <v-divider />

        <v-simple-table fixed-header>
          <thead>
            <tr>
              <th class="text-left">Nom pour les clients</th>
              <th class="text-left">Visible pour</th>
              <th class="text-left">Catégories</th>
              <th class="text-center">Visibilité</th>
              <th class="text-center"></th>
            </tr>
          </thead>

          <tbody class="button-table">
            <tr v-for="(item, index) in searchEveryWhere()" :key="index">
              <!--<td>{{-->
              <!--    item.documentName.length > 15 ?-->
              <!--        item.documentName.substring( 0, 15 ) + '...'-->
              <!--        : item.documentName-->
              <!--  }}-->
              <!--</td>-->
              <!--<td>{{-->

              <!--    item.iconName.length > 15 ?-->
              <!--        item.iconName.substring( 0, 15 ) + '...'-->
              <!--        : item.iconName-->
              <!--  }}-->
              <!--</td>-->

              <td>
                {{ item.name }}
              </td>

              <!--<td>-->
              <!--  {{ item.date | moment }}-->
              <!--</td>-->

              <td>
                <p
                  style="
                    max-width: 300px;
                    display: inline-flex;
                    align-items: center;
                    margin-bottom: 0;
                  "
                >
                  {{ findClients(item) }}
                </p>
              </td>
              <td>
                <p
                  style="
                    max-width: 300px;
                    display: inline-flex;
                    align-items: center;
                    margin-bottom: 0;
                  "
                >
                  {{ showType(item) }}
                </p>
              </td>

              <td>
                <v-btn
                  v-if="!item.visible"
                  color="orange"
                  text
                  @click="changeVisibility(item)"
                >
                  invisible
                </v-btn>
                <v-btn v-else color="green" text @click="changeVisibility(item)"
                  >visible
                </v-btn>
              </td>

              <td style="max-width: 300px">
                <div class="text-center">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="" v-bind="attrs" v-on="on"> action </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-btn color="main" text @click="openUpdateModal(item)">
                          editer
                        </v-btn>
                      </v-list-item>

                      <v-list-item>
                        <v-btn text>
                          <a :href="item.documentURL" target="_blank"> lien </a>
                        </v-btn>
                      </v-list-item>

                      <v-list-item>
                        <v-btn color="red" text @click="openDeleteModal(item)">
                          supprimer
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>

<script>
import { notifyKO } from "@/helper";
import { api, API_ROUTES } from "@/Services/api.common.service";
import { CATEGORIES } from "@/setup.const";
import Fuse from "fuse.js";

const defaultValueNewDocument = () => ({
  modalMode: "create",
  prevDocumentName: "",
  prevIconName: "",
  document: undefined,
  icon: undefined,
  visible: false,
  commandCategories: [],
  name: "",
  clients: [],
});

export default {
  props: ["documentsProps", "adminCat", "categories", "clients"],

  data() {
    return {
      openDelete: false,
      openNew: false,
      newDocument: defaultValueNewDocument(),
      currentDocument: undefined,
      documents: [...this.documentsProps],
      disabled: false,
      searchInput: "",
      id: undefined,
    };
  },

  methods: {
    searchEveryWhere() {
      if (this.searchInput.length === 0) return this.documents;

      const options = {
        includeScore: true,
        keys: ["name", "documentName", "iconName", "searchClient"],
      };
      const fuse = new Fuse(this.documents, options);
      const result = fuse.search(this.searchInput);
      return result.map((e) => e.item);
    },

    findClients(item) {
      const getName = (id) => this.clients.find((e) => e?.id === id)?.name;
      const clients = item?.clients?.map((id) => getName(id));

      if (clients.length === 0) return "Tous les Clients";
      return clients?.join(", ");
    },

    openDeleteModal(item) {
      this.currentDocument = item;
      this.openDelete = true;
    },

    openNewModal() {
      this.newDocument = defaultValueNewDocument();
      this.openNew = true;
    },
    isCreate() {
      return this.newDocument.modalMode === "create";
    },
    showType(item) {
      if (item?.commandCategories?.length === 0) return "Toutes les categoriés";
      const findCommand = (id) => CATEGORIES.find((x) => x.id === id)?.name;
      const cat = item?.commandCategories?.map(findCommand);
      return cat.join(", ");
    },

    openUpdateModal(document) {
      this.newDocument = defaultValueNewDocument();

      this.newDocument.modalMode = "update";
      this.newDocument.name = document.name;
      this.newDocument.clients = document.clients;
      this.newDocument.prevDocumentName = document.documentName;
      this.newDocument.prevIconName = document.iconName;
      this.newDocument.commandCategories = document.commandCategories;
      this.newDocument.visible = document.visible;
      this.newDocument.id = document.id;
      this.openNew = true;
    },

    async update() {
      const notifyBad = notifyKO.bind(this);

      try {
        this.disabled = true;
        const formData = new FormData();

        if (this.newDocument?.document)
          formData.append(
            "document",
            this.newDocument.document,
            this.newDocument.document.name
          );

        if (this.newDocument?.icon)
          formData.append(
            "icon",
            this.newDocument.icon,
            this.newDocument.icon.name
          );

        formData.append("visible", this.newDocument.visible);
        formData.append("clients", JSON.stringify(this.newDocument.clients));
        formData.append(
          "commandCategories",
          JSON.stringify(this.newDocument.commandCategories)
        );
        formData.append("name", this.newDocument.name);
        formData.append("adminCategory", this.adminCat.id);
        formData.append("id", document.id);

        const { data } = await api(true).post(
          `${API_ROUTES.adminDocuments.documents}/${this.newDocument.id}`,
          formData
        );

        const index = this.documents.findIndex(
          (e) => e.id === this.newDocument.id
        );

        this.documents[index] = data?.document;

        this.openNew = false;

        this.success();
      } catch (e) {
        this.errror();
        console.error(e);
      }
      this.disabled = false;
    },

    async createNew() {
      const notifyBad = notifyKO.bind(this);

      if (!this.newDocument.document) {
        notifyBad("Pas de fichier");
        return;
      }

      try {
        this.disabled = true;
        const formData = new FormData();
        formData.append(
          "document",
          this.newDocument.document,
          this.newDocument.document.name
        );
        formData.append(
          "icon",
          this.newDocument.icon,
          this.newDocument.icon.name
        );
        formData.append("visible", this.newDocument.visible);
        formData.append("clients", JSON.stringify(this.newDocument.clients));
        formData.append(
          "commandCategories",
          JSON.stringify(this.newDocument.commandCategories)
        );
        formData.append("name", this.newDocument.name);
        formData.append("adminCategory", this.adminCat.id);

        const { data } = await api(true).put(
          API_ROUTES.adminDocuments.documents,
          formData
        );

        if (data?.document) {
          this.documents.unshift(data.document);
        }
        this.openNew = false;

        this.success();
      } catch (e) {
        this.errror();
        console.error(e);
      }
      this.disabled = false;
    },

    async changeVisibility(document) {
      try {
        await api().put(
          `${API_ROUTES.adminDocuments.documents}/${document.id}/visible`,
          { visible: !document.visible }
        );

        document.visible = !document.visible;
        this.success();
      } catch (e) {
        this.errror();
      }
    },

    async deleteDocument() {
      try {
        this.openDelete = false;

        await api().delete(
          `${API_ROUTES.adminDocuments.documents}/${this.currentDocument.id}`
        );

        this.documents = this.documents.filter(
          (e) => e.id !== this.currentDocument.id
        );

        this.currentDocument = undefined;
        this.success();
      } catch (e) {
        console.error(e);
        this.errror();
      }
    },

    success() {
      this.$notify({
        group: "all",
        title: "Les modifications sont enregistrée",
        type: "success",
      });
    },
    errror() {
      this.$notify({
        group: "all",
        type: "warn",
        title: "Une erreur s'est produite",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.searchBar {
  input,
  input:focus {
    border: var(--dark-green) 2px solid !important;
    box-shadow: none !important;
    outline: var(--dark-green) !important;
  }

  .searchIcon {
    background: var(--dark-green);
    border: none;

    &:hover {
      background: var(--dark-green);
      cursor: default;
    }
  }

  .fa-search {
    color: white;
  }
}

.button-table button {
  display: block;
  margin: auto;
}

.title {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

h1 {
  margin: 0 !important;
  padding: 20px !important;
}
</style>
